const updateAttachmentCount = (contactID: string, attributes: string, count: number) => {
    const list = attributes
        ? attributes.split(',').filter((x) => x && x.split('_')[0] !== contactID)
        : []
    list.push(`${contactID}_${count}`)
    return list.join(',')
}

export default updateAttachmentCount
